/**
 * Skippable tasks editor for the test create flow. Tasks are optional at
 * creation: a test needs at least one task before it can run, but that is
 * enforced later in Setup, not here, so this block can always be left empty
 * ("add later in Setup"). Controlled by the parent (tasks: string[]).
 */
import React from 'react';

function TasksEditor({ tasks, onChange }) {
  const setTask = (i, value) => onChange(tasks.map((t, idx) => (idx === i ? value : t)));
  const addTask = () => onChange([...tasks, '']);
  const removeTask = (i) =>
    onChange(tasks.length === 1 ? tasks : tasks.filter((_, idx) => idx !== i));

  return (
    <div className="createflow-tasks">
      <div className="createflow-tasks-head">
        <div className="ut-create-section-label" style={{ margin: 0 }}>
          Tasks <span className="aero-tag">Optional</span>
        </div>
        <span className="createflow-note" style={{ margin: 0 }}>
          You can add these later in Setup.
        </span>
      </div>
      {tasks.map((task, idx) => (
        <div key={idx} className="createflow-task-row">
          <span className="createflow-task-num">{idx + 1}</span>
          <input
            className="aero-input"
            type="text"
            placeholder="Describe a task for testers..."
            value={task}
            onChange={(e) => setTask(idx, e.target.value)}
          />
          <button
            type="button"
            className="aero-btn aero-btn-ghost aero-btn-icon"
            onClick={() => removeTask(idx)}
            disabled={tasks.length === 1}
            title="Remove task"
            aria-label="Remove task"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      ))}
      <button
        type="button"
        className="aero-btn aero-btn-secondary aero-btn-sm"
        onClick={addTask}
      >
        + Add task
      </button>
    </div>
  );
}

export default TasksEditor;
